import type { SVGProps } from 'react';
import { SPRITE_SYMBOL_IDS } from '@/app/elements/svg/sprite/sprite-symbol-ids';

export const FanduelShieldSymbol = () => (
    <symbol id={SPRITE_SYMBOL_IDS.FANDUEL_SHIELD} viewBox="0 0 16 16" fill="none" data-testid="fanduel-shield-symbol">
        <g clipPath="url(#clip0_3308_17721)" filter="url(#filter0_i_3308_17721)">
            <path
                d="M3.44238 6.14409C4.50451 5.64829 5.62383 5.34697 6.72408 5.21549C6.84391 5.19905 6.89294 5.28123 6.87932 5.3771C6.74042 6.22627 6.64511 7.08914 6.6097 7.96022C6.60153 8.05883 6.54706 8.12458 6.43813 8.14649C5.82808 8.26702 5.23166 8.45603 4.57532 8.75734C5.1663 9.79004 5.87983 10.7351 6.66689 11.5267C6.75676 11.6226 6.81123 11.7212 6.83574 11.8828C7.04 13.2086 7.39676 14.5454 7.87336 15.8109C7.90332 15.8822 7.90332 15.9315 7.85974 15.9725C7.81345 16.0136 7.74536 16.0136 7.68 15.9725C2.92221 13.0552 0.0490213 7.826 0 2.34474C0 2.21326 0.0462979 2.11465 0.155234 2.05164C2.68255 0.62723 5.52579 -0.0575842 8.37991 0.0026795C8.50791 0.00815801 8.55149 0.117728 8.50247 0.22182C8.10757 1.0436 7.78077 1.88181 7.52204 2.71728C7.49208 2.8159 7.43217 2.8652 7.32596 2.87068C5.80085 2.95012 4.31387 3.29527 2.95217 3.86503C3.05021 4.64572 3.21906 5.40723 3.43966 6.14409H3.44238ZM8.71217 2.8789C8.61685 2.87068 8.55149 2.78303 8.58145 2.68989C8.88102 1.81607 9.22417 0.988812 9.61634 0.22182C9.66264 0.131425 9.73889 0.093075 9.84511 0.106771C11.9939 0.350565 14.0283 1.0299 15.842 2.0489C15.9537 2.11191 16.0027 2.21052 15.9973 2.342C15.9591 7.5329 13.3746 12.5019 9.02264 15.5041C8.94094 15.5617 8.83472 15.5288 8.79659 15.4329C8.48068 14.5783 8.22196 13.7127 8.03677 12.8744C8.01225 12.7621 8.03677 12.6772 8.12391 12.6115C10.7574 10.5242 12.6039 7.40963 13.0478 3.86503C11.7052 3.30896 10.2536 2.96108 8.71217 2.8789Z"
                fill="white"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_3308_17721"
                x="0"
                y="0"
                width="16"
                height="16.4"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="0.4" />
                <feGaussianBlur stdDeviation="0.2" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3308_17721" />
            </filter>
            <clipPath id="clip0_3308_17721">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </symbol>
);

const FDShield = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
        <use href={`#${SPRITE_SYMBOL_IDS.FANDUEL_SHIELD}`} />
    </svg>
);

export default FDShield;
